import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import Users from "./Users";
import ProjectSharing from "./ProjectSharing";
import useAuth from "src/hooks/useAuth";

export default function Sharing({ onClose }) {
  const [tabValue, setTabValue] = useState(0);
  const { user } = useAuth();
  const { settings } = user.company;
  const warehouseSharingEnabled = settings?.warehouse_sharing;

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const tabBar = (
    <Box>
      <Tabs value={tabValue} onChange={handleTabChange} aria-label="sharing tabs">
        <Tab label="External Stakeholders" sx={{ textTransform: "none" }} />
        <Tab label="Internal Staff" sx={{ textTransform: "none" }} />
        {warehouseSharingEnabled && <Tab label="Warehouse Sharing" sx={{ textTransform: "none" }} />}
      </Tabs>
    </Box>
  );

  const renderTabContent = () => {
    if (tabValue === 0) {
      return <Users onClose={onClose} userType="external">{tabBar}</Users>;
    } else if (tabValue === 1) {
      return <Users onClose={onClose} userType="internal">{tabBar}</Users>;
    } else if (warehouseSharingEnabled) {
      return <ProjectSharing settings={settings}>{tabBar}</ProjectSharing>;
    }
  };

  return (
    <Paper>
      <Box sx={{ mt: 2 }}>
        {renderTabContent()}
      </Box>
    </Paper>
  );
}
